import React, {Fragment} from 'react'
import { graphql, StaticQuery, Link } from 'gatsby'

class DownloadApp extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            device: 'desktop'
        }
    }

    componentDidMount() {
        if (typeof window !== 'undefined') {
			if (window.innerWidth > 1000) {
				this.setState({ device: 'desktop'})
			} else {
				this.setState({ device: 'mobile'})
			}
		}
    }

    render(){
        const {iPhone, appleLogo, googleLogo} = this.props.query;

        
            return(
                <section className="middle-sec">
                    <div className="custom-container">
                        <div className="for-mobile arrow">
                        <a href="javascript:void(0)" onClick={() => document.getElementById('quiz').scrollIntoView({behavior: 'smooth'})}>  <svg width="17" height="10" viewBox="0 0 17 10"><path fill="#32e2b9" fillRule="nonzero" stroke="#32e2b9" d="M15.782 1.203a.53.53 0 0 0-.744 0L8.5 7.693l-6.551-6.49a.53.53 0 0 0-.744 0 .518.518 0 0 0 0 .737l6.91 6.844c.103.102.231.153.372.153.128 0 .27-.051.372-.153l6.91-6.844a.507.507 0 0 0 .013-.737z"></path></svg></a>
                        </div> 
                        <div className="col-md-6 col-sm-6 col-lg-6 col-xs-12">
                            <figure><img src={iPhone.publicURL} /></figure>
                        </div>
                        <div className="col-md-6 col-sm-6 col-lg-6 col-xs-12">
                            <figcaption>
                                <h3>Den smartaste appen i <br/> mobilen </h3>
                                <p className="desktop">Albert är utvecklad och testad för att ge en så enkel och <br/> bra upplevelse som möjligt. Allt för att eleverna ska <br/> lyckas nå kunskapsmålen som läroplanen kräver.</p>
                                <p className="for-mobile">Albert är utvecklad och testad för att ge en så enkel <br/> och bra upplevelse som möjligt. Allt för att eleverna <br/> ska lyckas nå kunskapsmålen som läroplanen <br/> kräver.</p>
                                
                                <div className="app-store">
                                    <p>Funkar med App store och Google Play.</p>
                                    <img src={appleLogo.publicURL} />
                                    <img src={googleLogo.publicURL} />
                                </div>
                            </figcaption>
                        </div>
                    </div>
                </section>
            )
        
    }
}

export default (props) => (
    <StaticQuery
        query= { graphql`
                query {
                    iPhone: file(relativePath: {regex: "/iphone-mob/"}) {
                        publicURL
                    }
                    appleLogo: file(relativePath: {regex: "/apple_logo/"}){
                        publicURL
                    }
                    googleLogo: file(relativePath: {regex: "/google-play-badge/"}){
                        publicURL
                    }
                }`
            }
        render={(data)  => (
           <DownloadApp query={data} {...props}/>
        )}
    />
)